import { lazy, Suspense } from 'react';

const PdpSharedFrameIncludedLazyComponent = lazy(() =>
    import(/* webpackChunkName: "PdpSharedFrameIncluded" */ './PdpSharedFrameIncluded')
);

export const PdpSharedFrameIncludedLazy = props => (
    <Suspense fallback="">
        <PdpSharedFrameIncludedLazyComponent {...props} />
    </Suspense>
);
